/* eslint-disable @nfq/no-magic-numbers */
import {TransitionKeyframeBuilder} from 'Application/utils/TransitionKeyframeBuilder';

import type {Variants} from 'motion/react';

const Test = new TransitionKeyframeBuilder()
    .addProperty('clipPath', 'circle(0% at 50% 100%)')
    .to('clipPath', 'circle(200% at 50% 100%)', 0.6)
    .addProperty('height', 'calc(100vh - 160px)')
    .pause('height', 0.6)
    .to('height', 'calc(64vh - 0px)', 0.4)
    .compile();

export const HeroTransition: Variants = {
    enter: {
        clipPath: Test.clipPath,
        height: Test.height,
        transition: {
            duration: 1.5,
            ease: 'easeInOut',
            times: Test.times
        }
    },
    exit: {},
    initial: {
        clipPath: 'circle(0% at 50% 100%)',
        height: 'calc(100vh - 160px)'
    }
};